import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableMainImagePopup = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "mainimagepopup" */
        './MainImagePopup'
      )
  )
);

interface Props {
  requestClose: () => void;
  deviations: PapiDeviation[];
}

const LazyMainImagePopup: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LazyMainImagePopup">
    <Suspense fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}>
      <LoadableMainImagePopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazyMainImagePopup.displayName = 'LazyMainImagePopup';

export default LazyMainImagePopup;
